import { defineStore } from 'pinia';
import PublicService from '@/services/public.service';
import { useModuleStore } from './moduleStore';

export const useChampsFormulaireStore = defineStore('champsFormulaire', {
    state: () => ({
        id_module: null,
        list_generaux: [],
        list_specifiques: [],
        list_liaisons_champs_course: [],
    }),
    actions: {
        async fetch() {
            const moduleStore = useModuleStore();
            this.id_module = moduleStore.id;
            let res = await PublicService.getChampsFormulaire(this.id_module);

            if (res) {
                this.set(res);
            }
        },
        set(data) {

            this.list_generaux = data.list_generaux;
            this.list_specifiques = data.list_specifiques;
            this.list_liaisons_champs_course = data.list_liaisons_champs_course;

        }
    },
    getters: {
        isLoaded() {
            return this.list_generaux.length > 0 || this.list_specifiques.length > 0 || this.list_liaisons_champs_course.length;

        },



    },
});